<div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-500 to-primary-700 p-5">
  <div class="w-full max-w-md">
    <mat-card class="p-10 rounded-2xl shadow-2xl">
      <mat-card-content>
        <!-- Logo -->
        <div class="text-center mb-8">
          <!-- <img src="/favicon.ico" alt="The Carp Specialist" class="w-16 h-16 mb-4 rounded-xl mx-auto"> -->
          <h1 class="text-2xl font-semibold mb-2 text-gray-900">{{ 'login.title' | translate }}</h1>
          <p class="text-base text-gray-600 m-0 font-normal">{{ 'login.subtitle' | translate }}</p>
        </div>

        <!-- Login Form -->
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-4">
          <!-- Username Field -->
          <mat-form-field class="w-full">
            <mat-label>{{ 'login.email-label' | translate }}</mat-label>
            <input matInput
                   type="email"
                   formControlName="username"
                   [placeholder]="'login.email-placeholder' | translate"
                   autocomplete="username">
            <mat-icon matSuffix>person</mat-icon>
            @if (loginForm.hasError('required', 'username')) {
              <mat-error>{{ 'login.email-required' | translate }}</mat-error>
            }
            @if (loginForm.hasError('email', 'username')) {
              <mat-error>{{ 'login.email-invalid' | translate }}</mat-error>
            }
          </mat-form-field>

          <!-- Password Field -->
          <mat-form-field class="w-full">
            <mat-label>{{ 'login.password-label' | translate }}</mat-label>
            <input matInput
                   [type]="hidePassword ? 'password' : 'text'"
                   formControlName="password"
                   [placeholder]="'login.password-placeholder' | translate"
                   autocomplete="current-password">
            <button matIconButton
                    matSuffix
                    (click)="togglePasswordVisibility()"
                    [attr.aria-label]="'login.hide-password' | translate"
                    [attr.aria-pressed]="hidePassword"
                    type="button">
              <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            @if (loginForm.hasError('required', 'password')) {
              <mat-error>{{ 'login.password-required' | translate }}</mat-error>
            }
          </mat-form-field>

          <!-- Login Button -->
          <button mat-raised-button
                  type="submit"
                  class="w-full text-base font-medium mt-2"
                  [disabled]="isLoading()">

            @if (isLoading()) {
              <mat-icon>
                <mat-spinner diameter="16" />
              </mat-icon>
            } @else {
              <mat-icon>login</mat-icon>
            }
            {{ isLoading() ? ('login.signing-in' | translate) : ('login.sign-in' | translate) }}
          </button>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>
